import * as yup from 'yup';
import { Gender } from '@/entities/auth/gender.enum';
import { Local } from '@/entities/auth/local.enum';

export const createInsuranceCaseSchema = yup.object({
  customerData: yup
    .object({
      company: yup.string().notRequired(),
      gender: yup.string().oneOf(Object.values(Gender)).notRequired(),
      firstName: yup.string().notRequired(),
      lastName: yup.string().notRequired(),
      phone: yup.string().notRequired(),
      street: yup.string().notRequired(),
      zip: yup.string().notRequired(),
      city: yup.string().notRequired(),
      country: yup.string().notRequired(),
      dateOfBirth: yup.string().notRequired(),
      preferredLocal: yup.string().oneOf(Object.values(Local)).required(),
    })
    .notRequired(),
  location: yup.string().notRequired().nullable(),
  email: yup.string().email().notRequired(),
  startDate: yup.string().notRequired(),
  endDate: yup.string().notRequired(),
  insuranceProvider: yup.string().required(),
  insuranceData: yup
    .object()
    .when('insuranceProvider', ([insuranceProvider], schema) => {
      switch (insuranceProvider) {
        case 'axa':
          return schema.shape({
            referenceNumber: yup.string().required(),
            licencePlate: yup.string().notRequired(),
            initialDays: yup.number().required(),
            porscheCenter: yup.object({}).notRequired().nullable(),
            axaCategory: yup.string().notRequired(),
            maxDayPrice: yup.number().notRequired(),
          });
        case 'roland':
          return schema.shape({
            referenceNumber: yup.string().required(),
            licencePlate: yup.string().notRequired(),
          });
        case 'europ':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            porscheCenter: yup.object({}).notRequired().nullable(),
          });
        case 'volvo':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            volvoCategory: yup.string().notRequired().nullable(),
          });
        case 'jlr':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            jlrCategory: yup.string().notRequired().nullable(),
          });
        default:
          return schema.shape({});
      }
    })
    .required(),
});

export const insuranceCaseHandoverSchema = yup.object({
  insuranceProvider: yup.string().required(),
  insuranceData: yup
    .object()
    .when('insuranceProvider', ([insuranceProvider], schema) => {
      switch (insuranceProvider) {
        case 'axa':
          return schema.shape({
            referenceNumber: yup.string().required(),
            licencePlate: yup.string().required(),
            porscheCenter: yup.object({}).required(),
          });
        case 'roland':
          return schema.shape({
            referenceNumber: yup.string().required(),
            licencePlate: yup.string().required(),
          });
        case 'europ':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            porscheCenter: yup.object({}).required(),
          });
        case 'volvo':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            volvoCategory: yup.string().notRequired().nullable(),
          });
        case 'jlr':
          return schema.shape({
            referenceNumber: yup.string().required(),
            initialDays: yup.number().required(),
            jlrCategory: yup.string().notRequired().nullable(),
          });
        default:
          return schema.shape({});
      }
    })
    .required(),
});
